<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App',
  created() {
    // hash 模式下，用户输入 /mobile/login 不含 # 时，
    // Vue Router 初始化后 hash 已被设为 #/dashboard（因为 / 路由 redirect），
    // 无法用 !hash 判断。改用检查 pathname 与 hash 是否匹配。
    const pathname = window.location.pathname
    const hash = window.location.hash
    if (pathname.startsWith('/mobile') && !hash.startsWith('#/mobile')) {
      window.location.replace('#/mobile/login')
    }
  }
}
</script>
<style>
body { margin: 0; font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Microsoft YaHei', sans-serif; }
</style>
